import React, { useReducer, useEffect } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import  AppRouter  from "../routers/AppRouter";
import { AuthContex } from "../auth/AuthContext";
import { authReducer } from "../auth/authReducer";

import WorkRequest from '../views/workOrder/workRequest'
import redirect from '../views/family/redirect'
import {UpdateCurrentLocation} from '../actions/currentUrlActions'
import {useDispatch} from 'react-redux'
import RepairsLogin from "../views/repairs/RepairsLogin";
import EhubManagmentLogin from "../views/community/EhubManagmentLogin";
import TVMessagingLogin from "../views/tvmessages/TVMessagingLogin";
import { LegacyRepairs } from '../views/repairs/LegacyRepairs';
import { LegacyEhubManagment } from "../views/community/LegacyEhubManagment";
import { LegacyMessaging } from "../views/tvmessages/LegacyMessaging";



const customTheme = createTheme({
  palette: {
    primary: {
      main: "#1f1f1f",
    },
    secondary: {
      main: "#0586bf",
    },
  },
});

const init = () => {
  return JSON.parse(localStorage.getItem("user")) || { logged: false };
};

const refreshCurrentUrl = (dispatch) =>{
  try{
    if(!UpdateCurrentLocation) return false;

    dispatch(UpdateCurrentLocation())
  }catch(err){}
}

export const LayoutSimple = () => {

  const [user, dispatch] = useReducer(authReducer, {}, init)

  const d = useDispatch();
  
  let locationInterval = undefined;
  
  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(user));
     // eslint-disable-next-line react-hooks/exhaustive-deps
     locationInterval = setInterval(() => {
      refreshCurrentUrl(d)
    }, 1000);

    return () =>{
      clearInterval(locationInterval)
    }
  }, [user]);

  return (
    <div>
        <BrowserRouter>
          <ThemeProvider theme={customTheme}>
            <AuthContex.Provider value={{ user, dispatch }}>
            <Switch>

              <Route exact path='/login/repairs' render={props => <RepairsLogin {...props}/>} />
              <Route exact path='/login/ehub' render={props => <EhubManagmentLogin {...props}/>} />
              <Route exact path='/login/tvmessaging' render={props => <TVMessagingLogin {...props}/>} />
              <Route exact path='/legacyRepairs/' render={props => <LegacyRepairs {...props} action='close'/>}/>
              <Route exact path='/legacyEhub' render={props => <LegacyEhubManagment {...props} action='close'/>}/>
              <Route exact path='/legacyTVMessaging' render={props => <LegacyMessaging {...props} action='close'/>}/>

              <Route exact path='/detailsRequest/:idRequest?' render={props => <WorkRequest {...props} action='details'/>} />
              <Route exact path='/closerequest/:idRequest?' render={props => <WorkRequest {...props} action='close'/>}/>
              <Route exact path='/familyApp' component={redirect}/>
              <Route path="/" component={AppRouter} />;
            </Switch>
            </AuthContex.Provider>
          </ThemeProvider>
        </BrowserRouter>
    </div>
  );
};
